import React from 'react';
import { Container, Row, Col, Button, Badge } from 'react-bootstrap';
import { Card } from 'shards-react';
import { EntypoCheck } from 'react-entypo-icons';
import { primaryColor } from '../config/colors';
import { strings } from '../localization';
import { withRouter } from 'react-router-dom';
import { navigatePage, ORG_ID, ROUTE_PREFIX, TABLE_ID } from '../config';

const PaymentSuccessPage = ({match, location}) => {
  const {restaurantName} = match.params || {};
  console.log('DEBUG past order page in restaurantName', restaurantName);

  const { orderID } = location.state || {};
  console.log('orderID', orderID)

  const handleContinue = () => {
    navigatePage(`/${ROUTE_PREFIX}${restaurantName}/home`)
  };

  return (
    <Container fluid className="d-flex justify-content-center align-items-center vh-100">
      <Row className="w-100">
        <Col xs={12} sm={10} md={6} lg={4} className="mx-auto px-3">
          <Card className="p-4 shadow rounded text-center bg-white">
            {/* Success Icon */}
            <div className="mb-3 d-flex justify-content-center">
              <div className='px-2 d-flex justify-content-center align-items-center' style={{border: '1px solid green', background: 'green', height: 100, width: 100, borderRadius: 1000}}>
              <div className='px-2 d-flex justify-content-center align-items-center' style={{ background: 'white',  height: 80, width: 80, borderRadius: 1000}}>
                <EntypoCheck style={{ fontSize: '4rem', color: 'green' }} />
              </div>
              </div>
            </div>

            {/* Main Message */}
            <h3 className="fw-bold" style={{color: 'green'}}>{strings.payment_successful}</h3>
            <p className="text-muted mb-1">
              {strings.thank_you_for_order}
            </p>
            <p className="text-muted mb-3">
              {strings.your_food_is_being_prepared}
            </p>

            {/* Order ID */}
            <div className="mb-4">
              <strong className="text-secondary">
                {strings.your_order_id}:{' '}
                <strong style={{color: primaryColor, fontWeight: 'bold'}}>{orderID}</strong>
              </strong>
            </div>

            {/* Continue Button */}
            <div className="d-grid">
              <Button
                variant="primary"
                className="w-100 py-2"
                style={{ borderRadius: '10px' }}
                onClick={handleContinue}
              >
                {strings.continue}
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(PaymentSuccessPage);
